module.exports = __webpack_public_path__ + "img/w3_trash_delete_dark.69f1c5fc.png";